import { useT } from '../i18n/index.ts';
import { Chip } from '../ui/index.ts';

export function isTimelineUnsampled(input: {
  readonly timeline_unsampled?: true;
  readonly events: readonly unknown[];
  readonly metric: { readonly sampled?: boolean | null };
}): boolean {
  return input.timeline_unsampled === true
    || (input.events.length === 0 && input.metric.sampled === false);
}

function formatSampleRate(sampleRate: number | null | undefined): string {
  return sampleRate === null || sampleRate === undefined ? '—' : String(sampleRate);
}

export function LifecycleSamplingMarker({
  metric,
  events,
  timelineUnsampled,
  testId,
}: {
  readonly metric: {
    readonly sampled?: boolean | null;
    readonly sampleRate?: number | null;
  };
  readonly events: readonly unknown[];
  readonly timelineUnsampled?: true;
  readonly testId: string;
}): JSX.Element | null {
  const t = useT();
  if (isTimelineUnsampled({ timeline_unsampled: timelineUnsampled, events, metric })) {
    return (
      <Chip tone="warn" lamp={false} testId={testId}>
        {t('request_lifecycle.timeline.unsampled', { p: formatSampleRate(metric.sampleRate) })}
      </Chip>
    );
  }
  if (metric.sampled === true && metric.sampleRate !== null && metric.sampleRate !== undefined && metric.sampleRate < 1) {
    return (
      <span className="text-micro text-paper-low" data-testid={`${testId}-kept`}>
        {t('request_lifecycle.timeline.kept', { p: formatSampleRate(metric.sampleRate) })}
      </span>
    );
  }
  return null;
}
